import React, { useContext } from "react";
import { ChangeEvent, FC } from "react";
import { AuthContext } from "./AuthContextComponent";

interface InputProps {
  type: "text" | "number" | "email" | "password";
  name: string;
  label: string;
  placeholder: string;
  error?: boolean;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  icon?: React.ReactNode;
  hoverColor?: any;
}

const LoginInput: FC<InputProps> = ({
  type,
  name,
  label,
  error,
  placeholder,
  value,
  onChange,
  icon,
  hoverColor,
}) => {
  const { userInfo } = useContext(AuthContext);
  return (
    <div className="relative flex flex-col w-full gap-1 input-wrapper">
      <label
        htmlFor={label}
        className={`text-custom-petite ${
          userInfo?.theme === `DARK` ? `text-white` : `text-black`
        }`}
      >
        {label}
      </label>
      <input
        type={type}
        id={label}
        name={name}
        placeholder={placeholder}
        value={value}
        className={`rounded bg-slate-200 px-3 h-10 w-full pr-10 focus:ring-inherit placeholder:text-gray-400 text-sm ${
          error
            ? "border border-custom-default-hover placeholder:text-custom-default-hover"
            : ""
        }`}
        onChange={onChange}
      />
      {icon && (
        <span
          className={`absolute right-2 top-[2.7rem] transform -translate-y-1/2 ${
            hoverColor
              ? `hover:text-[#005faa]`
              : `hover:text-custom-default-hover`
          } hover:scale-125`}
        >
          {icon}
        </span>
      )}
    </div>
  );
};

export default LoginInput;
